import React, { useMemo } from 'react'
import { UserMenuOption, UserMenuStyled, UserMenuTrigger } from './UserMenu.styled'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { faCircleUser, faChevronDown } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useGetUserProfile } from 'Features/userProfile/api/getUserProfile'
import { useLogout } from 'Utils/logout'
import { Popover, StyledText } from '@clickcease/cc-client-components-lib'
import { VisibleOnlyToOwner } from 'src/hooks/VisibleOnlyToOwner'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const UserMenu = () => {
  const { t } = useTranslation('general')
  const { data } = useGetUserProfile()
  const { logOutUser } = useLogout()

  const navigate = useNavigate()

  const goToPage = (e: React.MouseEvent<HTMLDivElement>, url: string) => {
    e.stopPropagation()
    navigate(`/${url}`)
  }

  const userData = useMemo(() => {
    if (!(data instanceof Error) && data) {
      return data
    }
  }, [data])

  const disconnect = () => {
    logOutUser()
  }

  return (
    <Popover
      style={{ zIndex: 11 }}
      trigger={
        <UserMenuTrigger style={{ paddingRight: 0 }}>
          <FontAwesomeIcon icon={faCircleUser as IconProp} />
          <StyledText variant={'baseLight'}>
            {userData?.fullName || userData?.email || ''}
          </StyledText>
          <FontAwesomeIcon icon={faChevronDown as IconProp} />
        </UserMenuTrigger>
      }
      content={
        <UserMenuStyled>
          <UserMenuOption
            onClick={(e) => {
              goToPage(e, 'user-profile')
            }}
          >
            {t('user_menu.my_profile')}
          </UserMenuOption>
          <VisibleOnlyToOwner allowAdmin>
            <UserMenuOption
              onClick={(e) => {
                goToPage(e, 'account-settings')
              }}
            >
              {t('user_menu.account_settings')}
            </UserMenuOption>
          </VisibleOnlyToOwner>

          <UserMenuOption
            onClick={() => {
              disconnect()
            }}
          >
            {t('user_menu.logout')}
          </UserMenuOption>
        </UserMenuStyled>
      }
    />
  )
}
